import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import AuthService from "@/services/api/auth";
import type { ChangePasswordRequest } from "@/services/api/auth";

export function useChangePassword() {
  return useMutation({
    mutationFn: (params: ChangePasswordRequest) => AuthService.changePassword(params),
    onSuccess: () => {
      toast.success("Password updated successfully");
    },
    onError: (error: any) => {
      toast.error(error?.message || "Failed to update password");
    },
  });
}
